import { URL_API } from "../shared/constants";

export const BASE_URL = process.env.REACT_APP_BASE_URL || URL_API
